module.exports = __webpack_public_path__ + "static/img/person.5a8198f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person.jpg
// module id = yJIQ
// module chunks = 0